export default __webpack_public_path__ + "static/media/profile-icon.3733577e.svg";